import React, { useState } from "react";
import * as Scrivito from "scrivito";
import { getPageLink } from "utils";
import cx from "classnames";
import { useMediaQuery } from "react-responsive";
import { Icon, LinkButtonWithChevron } from "components";
import { Button, Collapse } from "reactstrap";
import { useResizeDetector } from "react-resize-detector";
import { SCREEN_LG } from "variables";

import s from "./LinksFooterWidget.module.scss";

interface LinksFooterWidgetProps {
  widget?: Scrivito.Widget;
}

Scrivito.provideComponent(
  "LinksFooterWidget",
  ({ widget }: LinksFooterWidgetProps) => {
    if (!widget) return null;
    const [isOpen, setIsOpen] = useState(false);
    const { width: listWidth, ref: listRef } = useResizeDetector();
    const isMobile = useMediaQuery({
      query: `(max-width: ${SCREEN_LG - 1}px)`,
    });

    let linksColumnsNumber = 3;
    if ((listWidth ?? 0) < 530 && (listWidth ?? 0) >= 390) {
      linksColumnsNumber = 2;
    } else if ((listWidth ?? 0) < 390) {
      linksColumnsNumber = 1;
    }

    const title = widget.get("title") && (
      <Scrivito.ContentTag
        content={widget}
        attribute="title"
        tag="h5"
        id="footer-links__title"
      />
    );
    const linkList = (widget.get("links") as Scrivito.Link[]) || [];
    const linkListMarkup = linkList.map((link, idx) => (
      <li key={`list-link-${idx}`}>
        <LinkButtonWithChevron to={getPageLink(link)}>
          {link.title() ||
            (link.isInternal()
              ? (link.obj()?.get("title") as string)
              : link.url())}
        </LinkButtonWithChevron>
      </li>
    ));

    const bootstrapListClasses = "p-0 m-0 list-unstyled d-grid";

    return (
      <div
        className={cx(s.listLinksWrapper, {
          [s.listLinksWrapperBorderBottom]: !isOpen,
        })}
      >
        {isMobile ? (
          <>
            <Button
              onClick={() => setIsOpen((prev) => !prev)}
              className={s.listLinksDropdown}
              outline
              data-testid="mobileBtn"
            >
              <h5 id="footer-links__title">
                {widget.get("title") as string}{" "}
                <Icon
                  iconName={
                    isOpen ? "chevron-up-regular" : "chevron-down-regular"
                  }
                  className="icon-16"
                />
              </h5>
            </Button>
            <Collapse isOpen={isOpen}>
              <ul className={cx(bootstrapListClasses, s.listLinks, "pt-3")}>
                {linkListMarkup}
              </ul>
            </Collapse>
          </>
        ) : (
          <>
            {title}
            <ul
              ref={listRef}
              className={cx(bootstrapListClasses, s.listLinks)}
              style={{
                gridTemplateColumns: `repeat(${linksColumnsNumber}, 1fr)`,
              }}
            >
              {linkListMarkup}
            </ul>
          </>
        )}
      </div>
    );
  },
);
